import * as React from "react";
import OutlineLikeEngageButton, {
  IProps as IBaseProps,
} from "../outlineLikeEngageButton";

interface IProps extends IBaseProps {
  questionId: string;
}

const QuestionLikeButton: React.FC<IProps> = props => (
  <OutlineLikeEngageButton {...props} />
);

export default QuestionLikeButton;
